import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom'; // Für die Navigation
import ConstructionManagerChart from './constructionManagerCardChart/ConstructionManagerChart';
import {MagnifyingGlassIcon} from '@heroicons/react/24/solid';
import {useConstructionManagerStore} from './store/ConstructionManagerStore'; // Importiere den Zustand Store

const ConstructionManagerCard = () => {
    const [searchTerm, setSearchTerm] = useState(''); // Zustand für den Suchbegriff
    const setSelectedManager = useConstructionManagerStore((state) => state.setSelectedManager); // Zugriff auf die Auswahlfunktion
    const navigate = useNavigate(); // Hook für Navigation

    // Funktion, die aufgerufen wird, wenn ein Bauleiter ausgewählt wird
    const handleManagerClick = (manager) => {
        setSelectedManager(manager); // Den Bauleiter im Zustand speichern
        navigate(`/reports/${manager.id}`); // Zur Detailseite mit der Bauleiter-ID navigieren
    };
    return (
        <div className='w-full text-sm font-color-4 flex flex-col'>
            <div className='flex justify-between items-center'>
                <p>Bauleiterauswertung</p>
                <div className='flex'>
                    <div
                        className='px-3 py-2 bg-color-5 rounded-full flex items-center shadow-sm border border-color-2 '>
                        <div className='w-40 lg:w-60 h-5 font-color-1 flex items-center'>
                            <div className='w-5 h-5'>
                                <MagnifyingGlassIcon/>
                            </div>
                            <input
                                type='text'
                                className='text-black text-sm font-light w-full bg-color-5 ml-2 focus:outline-none'
                                placeholder='Suche...'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center w-full h-2/3 my-4'>
                <ConstructionManagerChart searchTerm={searchTerm} onManagerClick={handleManagerClick}/>
            </div>
            <div className='flex items-center justify-center gap-2 mt-5'>
                <div className='w-2 h-2 bg-color-1 rounded-full'/>
                <div className='font-color-4'>Umsatz</div>
                <div className='ml-2 w-2 h-2 bg-color-4 rounded-full'/>
                <div className='font-color-4'>Kosten</div>
            </div>
        </div>
    );
};

export default ConstructionManagerCard;